import { Trans } from '@lingui/react/macro';
import { NoddiCard, NoddiRating, RatingButton } from 'noddi-ui-web';
import { KeyboardEvent, MouseEvent } from 'react';

interface Props {
  question: string;
  optional: boolean;
  rating: number | null;
  /** `picked` is a click or tap; arrow keys only move the selection, so the flow must not advance on them. */
  onRate: (value: number, picked: boolean) => void;
}

export const FeedbackRatingStep = ({ question, optional, rating, onRate }: Props) => (
  <NoddiCard contentClassName='flex flex-col gap-5'>
    <div className='flex flex-col gap-1'>
      <p className='text-lg font-semibold text-pretty'>{question}</p>
      {optional && (
        <p className='text-sm text-muted-foreground'>
          <Trans>Optional</Trans>
        </p>
      )}
    </div>
    <div className='flex w-fit flex-col gap-1'>
      <NoddiRating
        value={rating ?? 0}
        onChange={(event: MouseEvent<HTMLButtonElement> | KeyboardEvent<HTMLButtonElement>, value: number) =>
          onRate(value, event.type === 'click')
        }
        className='gap-1'
      >
        {Array.from({ length: 5 }).map((_, index) => (
          <RatingButton key={index} size='large' />
        ))}
      </NoddiRating>
      <div className='flex justify-between gap-4 text-xs text-muted-foreground'>
        <span>
          <Trans>Poor</Trans>
        </span>
        <span>
          <Trans>Very good</Trans>
        </span>
      </div>
    </div>
  </NoddiCard>
);
